import React, { Fragment, useEffect, useContext, useState } from "react";
import { AppContext } from "store/AppContext";
import AtkvaediCountSection from "./components/AtkvaediCountSection";
import OpnarKosningar from "./components/OpnarKosningar";
import VeljaKosninguAlert from "./components/VeljaKosninguAlert";
import { getOpnarKosningar } from 'common/services/apiService';


export default function Home() {
  const context = useContext(AppContext);
  const [opnarKosningar, setOpnarKosningar] = useState([]);
  const isAnyKosningActive = context.activeKosning.get.id !== undefined;
  const showVeljaKosninguAlert = context.activeKosning.get.id === undefined && opnarKosningar.length > 0;
  
  useEffect(() => {
    async function fetchOpnarKosningar() {
      const { data, isSuccess, error } = await getOpnarKosningar(context, []);
  
      if (isSuccess) {
        setOpnarKosningar(data);
        // If no open kosning, make sure none is active
        if (data.length === 0) {
          context.activeKosning.set({});
        }
      } else {
        console.error(error);
      }
    }

    fetchOpnarKosningar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  return (
    <Fragment>
      {isAnyKosningActive && (
        <AtkvaediCountSection />
      )}

      <VeljaKosninguAlert display={showVeljaKosninguAlert} />

      <div style={{ marginTop: "16px" }}>
        <OpnarKosningar opnarKosningar={opnarKosningar} />
      </div>

    </Fragment>
  );
}
